module.exports = __webpack_public_path__ + "img/3.e9449ae4.png";